import { Component } from '@angular/core';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle } from '@angular/material/expansion';
import { MatIcon } from '@angular/material/icon';
import { FxFlexDirective, FxLayoutAlignDirective, FxLayoutDirective, FxLayoutGapDirective, ResponsiveService } from '@rspl-ui';
import { StarRatingModule } from 'angular-star-rating';

import { BaseSectionComponent } from '../base-section/base.component';

@Component({
  selector: 'rspl-faq-split-landing',
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.scss',
  imports: [
    FxLayoutDirective,
    FxLayoutAlignDirective,
    FxLayoutGapDirective,
    FxFlexDirective,
    StarRatingModule,
    MatIcon,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
  ],
})
export class FaqSectionComponent extends BaseSectionComponent {
  faqs = [
    {
      question: 'Why is there a fee to donate my items to charity?',
      answer:
        'Through our fee-based all-in-one pickup service, you are covering the costs of the fuel; professionally licensed and insured haulers; possible recycling services; and the transportation needed to find your items a new home—expenses that would otherwise come out of the pockets of our partner charities.',
    },
    {
      question: 'How is ReSupply’s priority pick-up different from a free charity pickup?',
      answer: `Our veteran-owned and -led team at ReSupply is committed to putting your needs first, alongside those of our charity partners. We know how important your donations are, and while pick-ups are typically an added service for charities, many nonprofits trust us as their exclusive pick-up provider for several key reasons:
      <ol type="a">
      <li>Supports charities: Our partnership is entirely free for all charities. We do not charge charities anything for receiving donations, in order to support their mission</li>
      <li>Real-Time Support: We are here to support you with real-time scheduling and assistance for every donation. Our dedicated team of transitioning military members and veterans is always ready to lend a hand, no matter where you are or when you need us.</li>
      <li>Automated Tax Receipts: We ensure you receive tax receipts quickly and effortlessly. While charities usually handle their own tax receipts, our automated electronic distribution saves our partners the monetary and environmental costs of paper receipts.</li>
      <li>Quick Pick-Ups: We can schedule pickups as little as one day's notice. While free charity pickups often have wait times up to 6 weeks due to the high demand, ReSupply ensures your donation is picked up within 24-72 hours to accommodate your urgent needs.</li>
      <li>Handling Complex Situations: Our professional haulers are here to take the hard work off of your hands. Whether it is disassembling items or navigating stairs, we've got it covered. We carefully manage our workload to ensure that even complex, multi-story pickups are handled smoothly and efficiently, so you don’t have to lift a finger.</li>
      </ol>`,
    },
    {
      question: 'Will you pick up all of my items?',
      answer:
        'Absolutely! We try to pick up any and all of your items regardless of their condition. While our partner charities strive to accept everything that supports their mission, they can’t always take every item. If that is the case, we encourage our haulers to complete your pickup if possible, even if it requires multiple stops at additional charities. </br></br>In rare cases, if any items cannot be donated to any of our partnered charities, we will ensure they are recycled or ethically disposed of. Please note that there may be additional fees for any items that are recycled or disposed of.',
    },
    {
      question: 'Will I receive a tax receipt for my donation?',
      answer:
        'Yes! Once your items have been successfully donated to the charity, you will receive a link from ReSupply to your electronic tax receipt. You can print the receipt or download it to your computer for your records. If you have any questions about filling out the tax receipt, do not hesitate to contact our ReSupply support team! ',
    },
  ];

  constructor(public override responsiveService: ResponsiveService) {
    super(responsiveService);
  }
}
